import type { Dispatch, SetStateAction } from 'react';
import classNames from 'classnames';

import { colorPallete } from '@configs/color-pallete';
import Icon from '@utilities/icon';

import type { BookingTimeSlot } from './utils';
import { formatTimeSlot } from './utils';

type TimeSlotsGridProps = {
  slots: BookingTimeSlot[];
  activeTabLabel?: string;
  selectedTimeSlot: BookingTimeSlot | null;
  setSelectedTimeSlot: Dispatch<SetStateAction<BookingTimeSlot | null>>;
};

const TimeSlotsGrid = ({
  slots,
  activeTabLabel,
  selectedTimeSlot,
  setSelectedTimeSlot,
}: TimeSlotsGridProps) => {
  if (!slots.length) {
    return (
      <div className="flex flex-col items-center gap-y-4 p-4 pt-4">
        <Icon
          name="CircleExclamationFill"
          width={2.5}
          height={2.5}
          fill={colorPallete?.content?.tertiary}
        />
        <span className="text-center text-Body/Medium text-content-primary">
          {`در بازه ${activeTabLabel} هیچ نوبت خالی وجود ندارد!`}
        </span>
      </div>
    );
  }

  return (
    <div
      className="grid h-[300px] auto-rows-[32px] grid-cols-3 items-start gap-3 overflow-y-scroll px-4 pb-[100px]"
      data-testid="healthcare-time-slot"
    >
      {slots.map((slot) => (
        <button
          type="button"
          key={slot.key}
          disabled={!slot.isAvailable}
          data-testid={`healthcare-time-slot-${slot.key}`}
          onClick={() =>
            setSelectedTimeSlot((current) =>
              current?.key === slot.key ? null : slot,
            )
          }
          className={classNames(
            'flex h-8 w-full items-center justify-center rounded-full border border-border-primary bg-surface-primary px-2',
            !slot.isAvailable && 'cursor-not-allowed text-content-disabled',
            selectedTimeSlot?.key === slot.key &&
              '!border-border-inversePrimary bg-surface-secondary',
          )}
        >
          {formatTimeSlot(slot.startTime)}
        </button>
      ))}
    </div>
  );
};

export default TimeSlotsGrid;
